export default function () {
    // .variation-heading is added in /libs/woocommerce.php
    var variationHeading = $('.variation-heading');
    var variationWrap = $('.single_variation_wrap');

    if (variationHeading.length) {
        variationHeading.hide();

        // Show '.variation-heading' when show_variation event fires
        $(variationWrap).on('show_variation', function () {
            variationHeading.show();
        });

        // Hide '.variation-heading' when hide_variation event fires
        $(variationWrap).on('hide_variation', function () {
            variationHeading.hide();
        });
    }
}
